import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import TextareaInput from "../../Components/Inputs/TextareaInput";
import {useForm} from "react-hook-form";

export default function () {
  const {
    handleSubmit,
    reset,
    register,
    watch
  } = useForm();

  const {id} = useParams()
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get(  `pages/${id}/edit`).then(res => {
      if(res.data.status === 'success'){
        reset(res.data.page);
      }
    });
  }, []);

  const edit = data => {
    axios.put(`pages/${id}/update-keywords`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Page keywords has been updated successfully!', {
            icon: "success",
          });
          navigate("/seo");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit Page">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>
        <TextareaInput
          label="Keywords"
          name="keywords"
          register={register}
          required={false}
          rows={3}
          event={true}
          watch={watch}
          errorMessage={errors?.keywords}
        />
        <div className="text-muted fs-7 mb-2">
          Set keywords to the page separated by comma ( ex: word1, word2, word3 )
        </div>
        <div className="col-12 text-left mt-2">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block mt-4"
          />
        </div>
      </form>
    </Card>
  );
}